import Discipline from './Discipline';

export default Discipline;
